export const AUTH_TOKEN = 'auth-token';
export const AUTH_TOKEN_HEADER = 'authorization';
export const REFRESH_TOKEN_HEADER = 'RefreshToken';
